import {environment} from '../../../../environments/environment';

const baseURL = environment.apiURL;

const v1Base = `${baseURL}/api/v1`;

const prepareUrlParams = (url: string, params: any, skipParams = []) => {
  const urlInstance = new URL(url);
  let hasParams = false;
  let additionParams = ``;
  if (params) {
    const multiParams = [];
    for (const paramsKey in params) {
      if (params[paramsKey] !== undefined && params[paramsKey] !== null && !skipParams.includes(paramsKey)) {
        if (Array.isArray(params[paramsKey])) { // handle array params
          params[paramsKey].forEach(item => {
            multiParams.push(`${paramsKey}=${encodeURIComponent(item)}`);
          });
        } else if (('' + params[paramsKey]).length) { // handle single params
          hasParams = true;
          urlInstance.searchParams.append(paramsKey, params[paramsKey]);
        }
      }
    }
    if (multiParams.length) {
      additionParams = multiParams.join('&')
    }
  }
  let urlString = urlInstance.toString();
  if (additionParams) {
    urlString += (hasParams ? `&${additionParams}` : `?${additionParams}`)
  }
  return urlString;
}

export const v1URL = {

  user: {
    login: {
      url: `${v1Base}/user/login`,
      method: 'post',
    },

    logout: {
      url: `${v1Base}/user/logout`,
      method: 'post',
    },

    delete: {
      url: `${v1Base}/user/delete/confirm`,
      method: 'post',
    },

    profile: {
      update: {
        url: `${v1Base}/user/profile/update`,
        method: 'post',
      },
      fetch: {
        url: (payload?: { userId?: any; }) =>
          `${v1Base}/user${payload?.userId ? `/${payload?.userId}` : ``}/profile`,
        method: 'get',
      },
      edit: {
        url: `${v1Base}/user/profile`,
        method: 'patch',
      },
      delete: {
        url: (payload) => `${v1Base}/user/${payload?.userId}/profile/remove`,
        method: 'delete',
      },
      updateStatus: {
        url: `${v1Base}/user/profile/update-status`,
        method: 'patch',
      },
      updateAdultDetails: {
        url: `${v1Base}/user/profile/update-adult-details`,
        method: 'patch',
      }
    },

    register: {
      url: `${v1Base}/user/register`,
      method: 'post',
    },

    password: {
      forgot: {
        url: `${v1Base}/user/password/forgot`,
        method: 'post',
      },
      set: {
        url: `${v1Base}/user/password/set`,
        method: 'patch',
      },
      update: {
        url: `${v1Base}/user/password/update`,
        method: 'patch',
      },
    },

    registration: {
      'onboarding-step': {
        url: `${v1Base}/user/registration/onboarding-step`,
        method: 'get',
      },
      'consent-form-link': {
        url: (params) => prepareUrlParams(`${v1Base}/user/registration/consent-form-link`, params),
        method: 'get',
      },
      'user-consent-mark': {
        url: `${v1Base}/user/registration/user-consent-mark`,
        method: 'patch',
      },
      'save-answers': {
        url: `${v1Base}/user/registration/save-answers`,
        method: 'post',
      },
      'update-relation': {
        url: `${v1Base}/user/registration/update-relation`,
        method: 'put',
      },
      'sign-hipaa-consent': {
        url: (payload?: { participantId: any; }) =>
          `${v1Base}/user/registration/sign-hipaa-consent?participantId=${payload}`,
        method: 'patch',
      },
    },

    invite: {
      'send-invite': {
        url: `${v1Base}/user/invite`,
        method: 'post',
      },
      preview: {
        url: `${v1Base}/user/invite/preview`,
        method: 'post',
      },
      resendInvite: {
        url: (payload) => `${v1Base}/user/invite/${payload.userId}/resend`,
        method: 'post',
      },
      previewInvite: {
        url: (payload) => `${v1Base}/user/invite/${payload.userId}/invite-mail-template`,
        method: 'get',
      }
    },

    'ob-questions': {

      'ob-questions': {
        url: (params) => {
          let url = `${v1Base}/user/ob-questions?questionGroup=${params.questionGroup}`;
          if (params.participantId) {
            url += `&participantId=${params.participantId}`;
          }
          if (params.forRole) {
            url += `&forRole=${params.forRole}`;
          }
          return url;
        },
        method: 'get',
      },

      'save-responses': {
        url: `${v1Base}/user/ob-questions/save-responses`,
        method: 'post',
      },

    }


  },
  groups: {
    fetchAll: {
      url: (params?) => prepareUrlParams(`${v1Base}/groups`, params),
      method: 'get',
    },
    create: {
      url: `${v1Base}/groups`,
      method: 'post',
    },
    edit: {
      url: ((groupId: number) => `${v1Base}/groups/${groupId}`),
      method: 'patch'
    },
    sessions: {
      fetch: {
        url: (params) => `${v1Base}/groups/${params.groupId}/sessions`,
        method: 'get'
      },
      details: {
        fetch: {
          url: (params) => `${v1Base}/groups/${params.groupId}/sessions/${params.sessionId}`,
          method: 'get'
        },
        edit: {
          url: (params) => `${v1Base}/groups/${params.groupId}/sessions/${params.sessionId}`,
          method: 'patch'
        },
      },
      attendance: {
        fetch: {
          url: (params) => `${v1Base}/groups/${params.groupId}/sessions/${params.sessionId}/attendance?participantId=${params.participantId}`,
          method: 'get'
        },
        edit: {
          url: (params) => `${v1Base}/groups/${params.groupId}/sessions/${params.sessionId}/attendance`,
          method: 'patch'
        },

      },
      visitNotesReports: {
        url: (payload: any) => prepareUrlParams(`${v1Base}/report/visit-notes/generate`, payload),
        method: 'get'
      }
    },
    markDropout: {
      url: `${v1Base}/groups/participant/status`,
      method: 'patch'
    },
    delete: {
      url: (payload: any) => prepareUrlParams(`${v1Base}/groups/${payload.groupId}`, payload, [
        'groupId', 'isActive'
      ]),
      method: 'patch'
    }
  },
  clients: {
    url: `${v1Base}/clients`,
    method: 'get',
  },
  otp: {
    generate: {
      url: `${v1Base}/otp/generate`,
      method: 'post',
    },
    verify: {
      url: `${v1Base}/otp/verify`,
      method: 'post',
    }
  },
  canIAccess: {
    user: {
      url: (userId) => `${v1Base}/can-i-access/user/${userId}`,
      method: 'get'
    },
    group: {
      url: (groupId) => `${v1Base}/can-i-access/group/${groupId}`,
      method: 'get'
    },
    clientDetails: {
      url: (clientId) => `${v1Base}/can-i-access/client/${clientId}`,
      method: 'get'
    }
  },
  client: {
    details: {
      url: (clientId) => `${v1Base}/client/${clientId}`,
      method: 'get'
    },
    name: {
      url: (clientId) => `${v1Base}/client/${clientId}/name`,
      method: 'get'
    },
    update: {
      url: (clientId) => `${v1Base}/client/${clientId}`,
      method: 'patch'
    },
    add: {
      url: `${v1Base}/client`,
      method: 'post',
    },
    fetchAll: {
      url: (params?) => prepareUrlParams(`${v1Base}/client`, params),
      method: 'get',
    },
    delete: {
      url: (params) => `${v1Base}/client/${params.clientId}`,
      method: 'delete',
    },
  },
  filters: {
    clientStatus: {
      url: `${v1Base}/filters/base/clinicStatus`,
      method: 'get',
    },
    gender: {
      url: `${v1Base}/filters/base/gender`,
      method: 'get',
    },
    orgType: {
      url: `${v1Base}/filters/base/orgType`,
      method: 'get',
    },
    clients: {
      url: (params) => prepareUrlParams(`${v1Base}/filters/clients`, params),
      method: 'get',
    },
    groups: {
      url: (params?) => prepareUrlParams(`${v1Base}/filters/groups`, params),
      method: 'get'
    },
    surveys: {
      url: () => `${v1Base}/filters/surveys`,
      method: 'get'
    },
    participantUsernames: {
      url: (params?) => {
        let urlObj = new URL(`${v1Base}/filters/participants`);
        if (params) {
          for (const paramsKey in params) {
            if (params[paramsKey] !== undefined) {
              urlObj.searchParams.append(paramsKey, params[paramsKey]);
            }
          }
        }
        return urlObj.toString();
      },
      method: 'get',
    },
    adultUsernames: {
      url: (params?) => {
        let urlObj = new URL(`${v1Base}/filters/adults`);
        if (params) {
          for (const paramsKey in params) {
            if (params[paramsKey] !== undefined) {
              urlObj.searchParams.append(paramsKey, params[paramsKey]);
            }
          }
        }
        return urlObj.toString();
      },
      method: 'get',
    },
    roles: {
      url: `${v1Base}/filters/base/roles`,
      method: 'get',
    },
    groupStatus: {
      url: `${v1Base}/filters/base/groupStatus`,
      method: 'get',
    },
    groupType: {
      url: `${v1Base}/filters/base/groupLocation`,
      method: 'get',
    },
    measurements: {
      url: `${v1Base}/metric-options`,
      method: 'get',
    },
    coaches: {
      url: (params?:any) => prepareUrlParams(`${v1Base}/filters/coaches`, params),
      method: 'get',
    },
    relations: {
      url: `${v1Base}/filters/base/relations`,
      method: 'get',
    },
    sessionList: {
      url: `${v1Base}/filters/session-list`,
      method: 'get',
    },
    groupLocation: {
      url: `${v1Base}/filters/base/groupLocation`,
      method: 'get',
    },
    'user-status': {
      url: `${v1Base}/filters/base/userStatus`,
      method: 'get',
    },
    foodCategory: {
      url: `${v1Base}/filters/base/foodCategory`,
      method: 'get',
    },
  },
  username: {
    generate: {
      url: `${v1Base}/username/generate`,
      method: 'post',
    },
    verify: {
      url: `${v1Base}/username/verify`,
      method: 'post',
    },
    release: {
      url: (params) => `${v1Base}/username?uuid=${params.uuid}`,
      method: 'delete',
    },
    hasAssociatedLar: {
      url: (params) => `${v1Base}/user/has-associated-LAR?userId=${params.userId}`,
      method: 'get',
    }
  },
  participants: {
    url: (params) => prepareUrlParams(`${v1Base}/participants`, params),
    method: 'get'
  },
  group: {
    details: {
      url: (groupId) => `${v1Base}/groups/${groupId}`,
      method: 'get'
    },
    name: {
      url: (groupId) => `${v1Base}/groups/${groupId}/name`,
      method: 'get'
    },
    add: {
      url: `${v1Base}/groups`,
      method: 'post',
    },
    update: {
      url: (groupId) => `${v1Base}/groups/${groupId}`,
      method: 'patch'
    }
  },
  groupName: {
    generate: {
      url: `${v1Base}/groups/name/generate`,
      method: 'post',
    },
    verify: {
      url: `${v1Base}/groups/name/verify`,
      method: 'post',
    }
  },
  resourceHub: {
    resourceDetails: (id: string, slug: string) => ({
      url: `${v1Base}/resource/${id}/${slug}`,
      method: 'get'
    }),
    categories: {
      url: `${v1Base}/resource/category`,
      method: 'get'
    },
    subCategories: (subCategories: string) => ({
      url: `${v1Base}/resource/subcategory?categories=${subCategories}`,
      method: 'get'
    }),
    relatedResources: {
      url: `${v1Base}/resource/list`,
      method: 'post'
    },
    add: {
      url: `${v1Base}/resource`,
      method: 'post'
    },
    edit: (id: string) => ({
      url: `${v1Base}/resource/${id}`,
      method: 'patch'
    }),
    list: {
      url: `${v1Base}/resource/list`,
      method: 'post'
    },
    status: {
      url: `${v1Base}/filters/base/resourceStatus`,
      method: 'get'
    }
  },
  measurements: {
    options: {
      fetchAll: {
        url: (params?: {
          manage?: boolean,
          isActive?: boolean,
          groupId?: number,
          pageNumber?: number,
          limit?: number,
        }) => {
          const urlInstance = new URL(`${v1Base}/metric-options`);
          if (params) {
            for (const paramsKey in params) {
              if (params[paramsKey] !== undefined) {
                urlInstance.searchParams.append(paramsKey, params[paramsKey]);
              }
            }
          }
          return urlInstance.toString();
        },
        method: 'get'
      },
      add: {
        url: () => {
          const urlInstance = new URL(`${v1Base}/metric-options`);
          return urlInstance.toString();
        },
        method: 'post'
      },
      update: {
        url: (params: { metricId: number }) => {
          const urlInstance = new URL(`${v1Base}/metric-options/${params.metricId}`);
          return urlInstance.toString();
        },
        method: 'patch'
      },
    },
    values: {
      fetchAll: {
        url: (params: any) => {
          const urlInstance = new URL(`${v1Base}/metric-options/value`);
          for (const paramsKey in params) {
            if (params[paramsKey]) {
              urlInstance.searchParams.append(paramsKey, params[paramsKey]);
            }
          }
          return urlInstance.toString();
        },
        method: 'get'
      },
      add: {
        url: () => {
          const urlInstance = new URL(`${v1Base}/metric-options/value`);
          return urlInstance.toString();
        },
        method: 'post'
      },
      update: {
        url: (params: { valueId: number }) => {
          const urlInstance = new URL(`${v1Base}/metric-options/value/${params.valueId}`);
          return urlInstance.toString();
        },
        method: 'patch'
      },
      remove: {
        url: (params: { valueId: number }) => {
          const urlInstance = new URL(`${v1Base}/metric-options/value/${params.valueId}`);
          return urlInstance.toString();
        },
        method: 'delete'
      },
      updateMultiple: {
        url: () => {
          const urlInstance = new URL(`${v1Base}/metric-options/value/update`);
          return urlInstance.toString();
        },
        method: 'post'
      },
      removeMultiple: {
        url: () => {
          const urlInstance = new URL(`${v1Base}/metric-options/value/remove`);
          return urlInstance.toString();
        },
        method: 'post'
      },
    }
  },
  progress: {
    fetchWeightChartData: {
      url: (params) => prepareUrlParams(`${v1Base}/progress/weight/chart`, params),
      method: 'get'
    },
    fetchWeightChartTableData: {
      url: (params) => prepareUrlParams(`${v1Base}/progress/weight/chart/table`, params),
      method: 'get'
    },
    fetchHeightChartData: {
      url: (params) => prepareUrlParams(`${v1Base}/progress/height/chart`, params),
      method: 'get'
    },
    fetchHeightChartTableData: {
      url: (params) => prepareUrlParams(`${v1Base}/progress/height/chart/table`, params),
      method: 'get'
    },
    fetchBmiChartData: {
      url: (params) => prepareUrlParams(`${v1Base}/progress/bmi/chart`, params),
      method: 'get'
    },
    fetchBmiChartTableData: {
      url: (params) => prepareUrlParams(`${v1Base}/progress/bmi/chart/table`, params),
      method: 'get'
    },
    fetchBmiDefaultPercentile: {
      url: (params) => prepareUrlParams(`${v1Base}/progress/bmi/default-percentile`, params),
      method: 'get'
    },
    filters: {
      bmiGoal: {
        url: () => `${v1Base}/filters/base/bmiGoal`,
        method: 'get'
      },
      adultBmiGoal: {
        url: () => `${v1Base}/filters/base/adultBmiGoal`,
        method: 'get'
      }
    },
    fetchRedLightFoodChartData: {
      url: (params) => prepareUrlParams(`${v1Base}/progress/red-light-food/chart`, params),
      method: 'get'
    },
    fetchRedLightFoodChartTableData: {
      url: (params) => prepareUrlParams(`${v1Base}/progress/red-light-food/chart/table`, params),
      method: 'get'
    },
    fetchPAChartData: {
      url: (params) => prepareUrlParams(`${v1Base}/progress/physical-activity/chart`, params),
      method: 'get'
    },
    fetchPATableData: {
      url: (params) => prepareUrlParams(`${v1Base}/progress/physical-activity/table`, params),
      method: 'get'
    },
    fetchSTChartData: {
      url: (params) => prepareUrlParams(`${v1Base}/progress/screen-time/chart`, params),
      method: 'get'
    },
    fetchSTTableData: {
      url: (params) => prepareUrlParams(`${v1Base}/progress/screen-time/table`, params),
      method: 'get'
    },
    fetchJournalChartData: {
      url: (params) => prepareUrlParams(`${v1Base}/progress/journal/chart`, params),
      method: 'get'
    },
    fetchJournalChartTableData: {
      url: (params) => prepareUrlParams(`${v1Base}/progress/journal/chart/table`, params),
      method: 'get'
    },
  },
  dashboard: {
    users: {
      url: (params?) => prepareUrlParams(`${v1Base}/dashboard/users`, params),
      method: 'get'
    },
    participantCaregiver: {
      url: (params) => prepareUrlParams(`${v1Base}/dashboard/participant-caregiver`, params),
      method: 'get'
    },
    participantWeightInformation: {
      url: (params) => prepareUrlParams(`${v1Base}/dashboard/participant-weight`, params),
      method: 'get'
    },
    participantBehaviourInformation: {
      url: (params) => prepareUrlParams(`${v1Base}/dashboard/participant-behaviour`, params),
      method: 'get'
    },
  },
  survey: {
    sessionList: {
      url: `${v1Base}/filters/session-list`,
      method: 'get'
    },
    scheduleAccordingToList: {
      url: `${v1Base}/filters/base/scheduleAccordingTo`,
      method: 'get'
    },
    createSurveySendScheduleDetails: {
      url: `${v1Base}/survey`,
      method: 'post'
    },
    editSurveyApis: {
      url: (surveyId: string) => `${v1Base}/survey/${surveyId}`,
      method: 'patch'
    },
    filters: {
      clinics: {
        url: (params) => `${v1Base}/filters/clients?${params}`,
        method: 'get'
      },
      groups: {
        url: (queryParams: string) => `${v1Base}/filters/groups?${queryParams}`,
        method: 'get'
      }
    },
    surveyDetails: {
      url: (surveyId: string) => `${v1Base}/survey/${surveyId}`,
      method: `get`
    },
    manageSurveyList: {
      url: (params) => prepareUrlParams(`${v1Base}/survey`, params),
      method: `get`
    },
    summaryList: {
      url: (surveyId: string, urlParams: any) => prepareUrlParams(`${v1Base}/survey/${surveyId}/summary`, urlParams),
      method: `get`
    },
    myQuestionnaires: {
      url: (params) => prepareUrlParams(`${v1Base}/survey/my-surveys/list`, params),
      method: 'get'
    },
    pendingSurveyCount: {
      url: `${v1Base}/survey/my-surveys/pending-count`,
      method: 'get'
    },
    addSurveyResponse: {
      url: `${v1Base}/survey/save-response`,
      method: 'post'
    },
    surveyResponseReview: {
      url: (surveyId: string) => `${v1Base}/survey/${surveyId}/view-response`,
      method: 'get'
    },
    surveyResponseForReviewForAdmins: {
      url: (surveyId: string, queryParams) => prepareUrlParams(`${v1Base}/survey/${surveyId}/view-response`, queryParams),
      method: 'get'
    }
  },
  notification: {
    notificationList: {
      url: (params) => prepareUrlParams(`${v1Base}/notification`, params),
      method: 'get'
    },
    notificationDetails: {
      url: (notificationId: string) => `${v1Base}/notification/${notificationId}/details`,
      method: 'get'
    },
    markNotificationAsRead: {
      url: `${v1Base}/notification/mark-as-read`,
      method: 'patch'
    },
    triggerNotification: {
      url: (params) => prepareUrlParams(`${v1Base}/notification/trigger`, params),
      method: 'post'
    },
    deleteNotification: {
      url: `${v1Base}/notification`,
      method: 'delete'
    }
  },
  imageUpload: {
    getSignedUrl: {
      url: (params) => prepareUrlParams(`${v1Base}/cdn/upload-url`, params),
      method: 'get'
    },
    deleteUploadedImage: {
      url: `${v1Base}/cdn/remove-file`,
      method: 'delete'
    }
  },
  sideNavWeeksList: {
    fetchAll: {
      url: (params?) => {
        let urlObj = new URL(`${v1Base}/groups/${params?.groupId}/week`);
        if (params?.pageNumber) {
          urlObj.searchParams.append('pageNumber', params?.pageNumber);
        }
        if (params?.limit) {
          urlObj.searchParams.append('limit', params?.limit);
        }
        if (params?.clientId) {
          urlObj.searchParams.append('clientId', params?.clientId);
        }
        if (params?.forUserId) {
          urlObj.searchParams.append('forUserId', params?.forUserId);
        }

        return urlObj.toString();
      },
      method: 'get'
    }
  },
  reports: {
    getAllReportsType: {
      url: `${v1Base}/filters/report-type`,
      method: 'get'
    },
    filters: {
      clinics: {
        url: (params) => `${v1Base}/filters/clients?${params}`,
        method: 'get'
      },
      groups: {
        url: (queryParams: string) => `${v1Base}/filters/groups?${queryParams}`,
        method: 'get'
      },
      participant: {
        url: (queryParams: any) => prepareUrlParams(`${v1Base}/filters/participants`, queryParams),
        method: 'get'
      },
      groupFilters: {
        url: (queryParams: any) => prepareUrlParams(`${v1Base}/filters/groups`, queryParams),
        method: 'get'
      }
    },
    generateReports: {
      url: (reportType: string) => `${v1Base}/report/${reportType}/generate`,
      method: 'post'
    },
    fetchReports: {
      url: (params) => prepareUrlParams(`${v1Base}/report`, params),
      method: 'get'
    },
    downloadReports: {
      url: (reportId) => `${v1Base}/report/${reportId}/download`,
      method: 'get'
    },
    reGenerateReports: {
      url: (reportId) => `${v1Base}/report/${reportId}/re-generate`,
      method: 'post'
    },
    checkReportStatus: {
      url: (reportId) => `${v1Base}/report/${reportId}/status`,
      method: 'get'
    }
  },
  weekListSummary: {
    fetch: {
      url: (params?) => {
        let urlObj = new URL(`${v1Base}/groups/${params?.groupId}/week-list/summary`);
        if (params?.pageNumber) {
          urlObj.searchParams.append('pageNumber', params?.pageNumber);
        }
        if (params?.limit) {
          urlObj.searchParams.append('limit', params?.limit);
        }
        if (params?.forUserId) {
          urlObj.searchParams.append('forUserId', params?.forUserId);
        }
        if (params?.sortOrder) {
          urlObj.searchParams.append('sortOrder', params?.sortOrder);
        }
        if (params?.sortColumn) {
          urlObj.searchParams.append('sortColumn', params?.sortColumn);
        }

        return urlObj.toString();
      },
      method: 'get'
    }
  },
  weekDetails: {
    fetch: {
      url: (params?) => {
        let urlObj = new URL(`${v1Base}/groups/${params?.groupId}/week/${params?.weekNumber}`);
        if (params?.forUserId) {
          urlObj.searchParams.append('forUserId', params?.forUserId);
        }
        return urlObj.toString();
      },
      method: 'get'
    }
  },
  contracts: {
    fetch: {
      url: (params?) => {
        let urlObj = new URL(`${v1Base}/groups/${params?.groupId}/week/${params?.weekNumber}/contract`);
        if (params?.forUserId) {
          urlObj.searchParams.append('forUserId', params?.forUserId);
        }
        return urlObj.toString();
      },
      method: 'get'
    },
    update: {
      url: (params?) => {
        let urlObj = new URL(`${v1Base}/groups/${params?.groupId}/week/${params?.weekNumber}/contract`);
        if (params?.forUserId) {
          urlObj.searchParams.append('forUserId', params?.forUserId);
        }
        return urlObj.toString();
      },
      method: 'post'
    }
  },
  behaviourTracker: {
    score: {
      url: `${v1Base}/behaviour-tracker/journal/fill`,
      method: 'put'
    }
  },
  journal: {
    weekDetails: {
      url: (params: { groupId: any, weekNumber: any }, queryParams) => prepareUrlParams(`${v1Base}/groups/${params.groupId}/week/${params.weekNumber}`, queryParams),
      method: 'get'
    },
    eJournalDetails: {
      url: (params) => prepareUrlParams(`${v1Base}/behaviour-tracker/e-journal`, params),
      method: 'get'
    },
    mealType: {
      url: `${v1Base}/filters/base/mealType`,
      method: 'get'
    },
    todType: {
      url: `${v1Base}/filters/base/todType`,
      method: 'get'
    },
    addEJournal: {
      url: `${v1Base}/behaviour-tracker/e-journal/fill`,
      method: 'post'
    },
    recordType: {
      url: `${v1Base}/filters/base/recordType`,
      method: 'get'
    },
    deleteRecords: {
      url: (payload: { recordId: any, recordType: any }) => `${v1Base}/behaviour-tracker/e-journal/${payload.recordType}/${payload.recordId}`,
      method: 'delete'
    },
    searchFood: {
      url: (payload) => prepareUrlParams(`${v1Base}/behaviour-tracker/e-journal/items/food`, payload),
      method: 'get'
    },
    searchPhysicalActivity: {
      url: (payload) => prepareUrlParams(`${v1Base}/behaviour-tracker/e-journal/items/physical-activity`, payload),
      method: 'get'
    },
    editRecord: {
      url: (params: { recordType: any, recordId: any },) => `${v1Base}/behaviour-tracker/e-journal/${params.recordType}/${params.recordId}`,
      method: 'patch'
    },
    screenType: {
      url: `${v1Base}/filters/base/screenType`,
      method: 'get'
    },
    activityType: {
      url: `${v1Base}/filters/base/activityType`,
      method: 'get'
    },
  },
  avatars: {
    url: `${v1Base}/avatars`,
    method: 'get',
  },
  foodGuide: {
    list: {
      url: (payload) => prepareUrlParams(`${v1Base}/food-guide`, payload),
      method: 'get'
    },
    getById: {
      url: (id: number) => `${v1Base}/food-guide/${id}`,
      method: 'get'
    },
    create: {
      url: `${v1Base}/food-guide`,
      method: 'post'
    },
    update: {
      url: (id: number) => `${v1Base}/food-guide/${id}`,
      method: 'put'
    },
    retire: {
      url: (id: number) => `${v1Base}/food-guide/${id}/retire`,
      method: 'post'
    },
    unretire: {
      url: (id: number) => `${v1Base}/food-guide/${id}/unretire`,
      method: 'post'
    },
    history: {
      url: (id: number, payload?) => prepareUrlParams(`${v1Base}/food-guide/${id}/history`, payload),
      method: 'get'
    },
  },
}

